/**
 * @desc 校验供应商是否认证
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<boolean>;
export function request(userNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierAccount/checkSupplierCertified/${userNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
